import { AxiosRequestConfig } from "axios";
import { ApiService } from "../../../config";
import { handleError } from "../../../utils/parseApiReturn";
import { toast } from "react-toastify";
import { handleToken } from "../../../utils/expiredTokenLogout";

interface GetProfilesParams {
  status?: string;
  ranking?: string;
  localidade?: string;
  query?: string;
  page?: number;
  size?: number;
  sort?: string[];
  token: string;
}

const getSellers = async (params: GetProfilesParams): Promise<any> => {
  try {
    const { token, ...queryParams } = params;
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: queryParams,
    };

    const result = await ApiService.get("/users/staff", config);
    const { data, error } = result.data;
    if (error) {
      handleToken(result.data.message);
      const { message } = handleError(error, "Erro ao obter Vendedores");
      toast.error(message);
      return null;
    }
    return data;
  } catch (error) {
    const { message } = handleError(
      error,
      "Erro inesperado ao obter Vendedores",
    );
    toast.error(message);
    return null;
  }
};

const createSeller = async (payload: any, token: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const result = await ApiService.post(`/users/create`, payload, config);
    return result;
  } catch (error) {
    const { message } = handleError(
      error,
      "Não foi possível criar o usuário.",
    );
    toast.error(message);
    return null;
  }
};

const updateSeller = async (id: string, payload: any, token: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const result = await ApiService.put(`/users/${id}`, payload, config);
    return result;
  } catch (error) {
    const { message } = handleError(
      error,
      "Erro inesperado ao atualizar usuário.",
    );
    toast.error(message);
    return null;
  }
};
const deleteUser = async (id: string, token: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const result = await ApiService.delete(`users/${id}`, config);
    return result.data.data;
  } catch (error) {
    const { message } = handleError(
      error,
      "Erro inesperado ao excluir usuário.",
    );
    toast.error(message);
    return null;
  }
};

const getProfileAccesses = async (id: string, token: string): Promise<any> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const result = await ApiService.get(`/users/${id}/profile-accesses`, config);
    const { data, error } = result.data;
    if (error) {
      handleToken(result.data.message);
      const { message } = handleError(error, "Erro ao obter acessos do usuário");
      toast.error(message);
      return null;
    }
    return data;
  } catch (error) {
    const { message } = handleError(
      error,
      "Erro inesperado ao obter acessos do usuário.",
    );
    toast.error(message);
    return null;
  }
};

export const SellersService = {
  getSellers,
  createSeller,
  updateSeller,
  deleteUser,
  getProfileAccesses,
};
